module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// ../~/symbol-observable/index.js
// module id = 1388
// module chunks = 0